import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { LocalizedLink } from '@/components/LocalizedLink'
import contattiImg from '@/assets/images/sections/Contatti.jpg'

export function ContactCTA() {
  const { t } = useTranslation('home')

  return (
    <section className="relative py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: `url(${contattiImg})`,
        }}
      />
      <div className="absolute inset-0 bg-gray-900/80" />

      <div className="relative container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center text-white max-w-2xl mx-auto"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6">
            {t('cta.title')}
          </h2>
          <p className="text-base sm:text-lg text-white/90 mb-6 sm:mb-8">
            {t('cta.description')}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Button asChild size="lg" className="bg-white text-gray-900 hover:bg-gray-100 text-sm sm:text-base">
              <LocalizedLink to="contacts">{t('common:buttons.contactUs')}</LocalizedLink>
            </Button>
            <Button asChild size="lg" variant="outline" className="border-white text-white hover:bg-white hover:text-gray-900 text-sm sm:text-base">
              <LocalizedLink to="careers">{t('common:buttons.workWithUs')}</LocalizedLink>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
